import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import StartPage from '../components/Start.vue';
import QuestionPage from '../components/Question.vue';
import EndPage from '../components/End.vue';
import MailPage from '../components/Mail.vue';
import ThanksPage from '../components/Thanks.vue';
var DiagnosisPage = /** @class */ (function (_super) {
    __extends(DiagnosisPage, _super);
    function DiagnosisPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.page = 'start';
        return _this;
    }
    DiagnosisPage.prototype.start = function () {
        this.page = 'question';
    };
    DiagnosisPage.prototype.mail = function () {
        this.page = 'mail';
    };
    DiagnosisPage.prototype.thanks = function () {
        this.page = 'thanks';
    };
    DiagnosisPage.prototype.end = function () {
        this.page = 'end';
    };
    __decorate([
        Prop({ type: Number, required: true })
    ], DiagnosisPage.prototype, "surveyId", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], DiagnosisPage.prototype, "liffId", void 0);
    DiagnosisPage = __decorate([
        Component({
            components: { StartPage: StartPage, QuestionPage: QuestionPage, EndPage: EndPage, MailPage: MailPage, ThanksPage: ThanksPage },
        })
    ], DiagnosisPage);
    return DiagnosisPage;
}(Vue));
export default DiagnosisPage;
